import React, { createRef, useEffect } from "react";
import { useState, useRef } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Autocomplete from "@mui/material/Autocomplete";
import Select from "@mui/material/Select";
import { useFormik } from "formik";
import * as Yup from "yup";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import useAxios from "../../../api/useAxios";
import "./JobSeekerRegForm.css";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import CloseIcon from "@mui/icons-material/Close";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import InputAdornment from "@mui/material/InputAdornment";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import {
  MailOutline as MailOutlineIcon,
  ShareLocationRounded as ShareLocationRoundedIcon,
} from "@mui/icons-material";
import logo from "../../../img/logo_for-landingpage-3.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { industry } from "./cdata";
import { useNavigate, Outlet } from "react-router";
import { ROUTINGDATA } from "../../ROUTINGDATA";
import Toplogo from "../../../img/logo_for-landingpage-3.png";
import { FormHelperText, CircularProgress } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import Tooltip from "@mui/material/Tooltip";
import SearchIcon from "@mui/icons-material/Search";
import Popper from "@mui/material/Popper";
import axios from "axios";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

let response = "";

const exceptThisSymbols = ["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"];

function JobSeekerRegForm() {
  const ref = React.createRef(null);
  const navigate = useNavigate();
  const theme = useTheme();
  //  translation
  const { t, i18n, ready } = useTranslation();
  //
  const axiosData = useAxios();
  const [WorkType, SetWorktype] = useState("Fresher");
  const [active, setActive] = useState(null);
  const [graduationType, SetgraduationType] = useState("Student");
  const [data, setData] = useState(false);
  const [file, setFile] = useState("");
  const [resume, setResume] = useState("");
  const [open, setOpen] = useState(false);
  let [mobileError, setmobileError] = useState("");
  let [emailError, setEmailError] = useState(true);
  const [valid, setvalid] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [focusout, setfocus] = useState();
  const [formEmail, setFormEmail] = useState("");
  const [formEmailError, setFormEmailError] = useState("");
  const [focusb, setfocusb] = useState();
  const [focusPin, setFocusPin] = useState(false);
  const [emailPopUp, setEmailPopUp] = useState(false);
  const [mobilePopUp, setMobilePopUp] = useState(false);
  const [industryArray, setIndustryArray] = useState();

  const handleClick1 = () => {
    setOpen(true);
  };
  const handleClose1 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const [experience, setExperience] = useState([]);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const filterOptions = (options, { inputValue }) => {
    const inputValueLower = inputValue.toLowerCase();
    const startsWithInput = [];
    const containsInput = [];

    options.forEach((option) => {
      const optionLower = option.toLowerCase();
      if (optionLower.startsWith(inputValueLower)) {
        startsWithInput.push(option);
      } else if (optionLower.includes(inputValueLower)) {
        containsInput.push(option);
      }
    });

    return [...startsWithInput, ...containsInput];
  };

  const MAX_FILE_SIZE = 1048576 * 10;
  const errors = {};
  const error = () => {
    errors.email_id = `email is exist `;
  };
  const [alertm, setalert] = useState(false);
  const [alerte, setalerte] = useState(false);
  useEffect(() => {
    if (alertm !== false) {
      setMobilePopUp(true);
      formik.setFieldValue("mobile_number", "");
    }
    setalert(false);
  }, [alertm]);
  useEffect(() => {
    if (alerte !== false) {
      setEmailPopUp(true);
      setFormEmail("");
      formik.setFieldValue("email_id", "");
    }
    setalerte(false);
  }, [alerte]);
  const validate = async (values) => {
    const errors = {};

    if (!values.mobile_number) {
      errors.mobile_number = t("Mobile_Number_must_be_Required");
      setfocusb(true);
      setvalid(true);
    } else if (/^\d{9}$/.test(values.mobile_number)) {
      setvalid(true);
    } else if (/^\d{10}$/.test(values.mobile_number)) {
      if (valid) {
        const controller = new AbortController();
        try {
          const response = await axiosData.get(
            `users/Mobile/${values.mobile_number}`
          );

          if (response.status === 200) {
            setalert(true);
          } else if (response.status === 204) {
            setalert(false);
          }

          setvalid(false);

          return () => controller.abort();
        } catch (error) {}
      }
    }

    return errors;
  };
  const fileInputField = useRef(null);
  const reader = new FileReader();
  const [selectedIndustry, setSelectedIndustry] = useState();
  const handleFileChange = (e) => {
    if (e.target.files[0].size > MAX_FILE_SIZE) {
      setFile("File is too large");
      setResume(false);
    } else {
      setResume(e.target.files[0]);
      setFile(e.target.files[0].name);
    }
    setData(e.target.files[0].size);
  };
  const deleteFile = () => {
    fileInputField.current.value = "";
    setFile(null);
    setData(null);
    setResume(null);
    formik.setFieldValue("fileUpload", null);
  };
  const formik = useFormik({
    initialValues: {
      full_name: "",
      gender: "Male",
      email_id: "",
      mobile_number: "",
      industry: "",
      Experience: "",
      work_status: "",
      currentLocation: "",
      votingDistrict: "",
      mpConstituency: "",
      mlaConstituency: "",
      pincode: "",
      fileUpload: null,
      graduation: "Student",
      area_name: "",
      pincode_num: "",
    },
    validate,
    validationSchema: Yup.object({
      full_name: Yup.string()
        .max(50, t("Must_be_50_characters_or_less"))
        .required(t("FullName_must_be_Required")),
      gender: Yup.string().required("gender must be Required"),
      mobile_number: Yup.number()
        .min(6000000000, t("Not_Valid_Mobile_Number!"))
        .max(9999999999, t("Not_Valid_Mobile_Number!"))
        .required(t("Mobile_Number_must_be_Required")),
      industry: Yup.string().required(t("Select_Industry")),
      currentLocation: Yup.string()
        .max(50, t("Must_be_50_characters_or_less"))
        .required(t("Current_Location_must_be_Required")),
      // votingDistrict: Yup.string().required(t("Select_District")),
      // mpConstituency: Yup.string().required(t("Select_MP_Constituency")),
      // mlaConstituency: Yup.string().required(t("Select_MLA_Constituency")),
      // pincode: Yup.string().required(t("pincode_is_Required")),
      Experience:
        WorkType === "Experienced"
          ? Yup.string().required(t("Experience_is_required"))
          : Yup.string(),
      graduation: Yup.string().required("graduation must be Required"),
    }),
    onSubmit: (values) => {
      let mla = values.mlaConstituency;
      let mla2 = mla.replace(/[-\s.,]+/g, "");
      values.mlaConstituency = mla2;

      if (resume) {
        values.fileUpload = resume;
        values.email_id = formEmail;
      }
      if (graduationType) {
        values.work_status = WorkType;
      }
      if (pincodeNumData) {
        values.pincode_num = pincodeNumData[0];
        values.area_name = pincodeNumData[1];
      }
      setIsSubmitting(true);
      axiosData
        .post("seekers", values, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          axiosData.post(
            "users",
            {
              usertype: "seeker",
              status: "InActive",
              uniqueId: values.mobile_number,
              password: values.mobile_number,
              email_id: values.email_id,
              user_id: res.data.user_id,
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          setIsSubmitting(false);
          formik.handleReset("");
          deleteFile();
          navigate(
            `${ROUTINGDATA.LAND}${ROUTINGDATA.MAIN}${ROUTINGDATA.ThankYou}`
          );
          setFile(false);
          handleClick1();
        })
        .catch((err) => console.log(err));
    },
  });
  const handleEmailBlur = () => {
    if (!formEmail) {
      setFormEmailError(t("EmailId_must_be_Required"));
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formEmail)) {
      setFormEmailError(t("Invalid_email_format"));
    } else {
      setFormEmailError("");
    }
  };
  const handleChange = (e) => {
    setfocusb(false);
    const { value } = e.target;
    if (value.length <= 10) {
      formik.handleChange(e);
    }
  };

  const handleChange1 = (e) => {
    setFocusPin(false);
    const { value } = e.target;
    if (value.length <= 6) {
      formik.handleChange(e);
    }
  };

  const handleEmailChange = async (event) => {
    const email_id = event.target.value
      .replace(/[^a-z0-9@.]/gi, "")
      .toLowerCase();
    setFormEmail(email_id);
    if (!email_id) {
      setfocus(true);
      setFormEmailError(t("EmailId_must_be_Required"));
      errors.email_id = t("EmailId_must_be_Required");
      setEmailError(true);
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email_id)) {
      setfocus(false);
      setFormEmailError(t("Invalid_email_format"));
      errors.email_id = t("Invalid_email_format");
    } else if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email_id)) {
      setEmailError(true);
      if (emailError) {
        try {
          const response = await axiosData.post(`users/email`, {
            email_id: email_id,
          });

          if (response.status === 200) {
            setalerte(true);
          } else if (response.status === 204) {
            formik.setFieldValue("email_id", event.target.value);

            setFormEmailError("");
          }
        } catch (error) {
          formik.setFieldValue("email_id", event.target.value);

          setFormEmailError("");
        }
      }
    }
  };
  const [mpConstituency, setMP] = useState({
    code: 4,
    District: "",
    ParlimentConstituency: [],
  });
  var [mlaConstituency, setMLA] = useState([]);

  const [districtData, setDistrictData] = useState([]);
  const [district, setDistrict] = useState([]);
  const vodingDistrict = async () => {
    try {
      const getOneAxios = await axiosData.get(`/district`);
      const data = getOneAxios.data;
      if (data) {
        const getDistrict = data.map((i) => {
          return i.District;
        });
        getDistrict.sort();
        setDistrictData(getDistrict);
        setDistrict(data);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  const mlaSelection = (value) => {
    formik.setFieldValue("mpConstituency", "");
    formik.setFieldValue("mlaConstituency", "");
    district.map((element) => {
      if (element.District === value) {
        setMLA([]);
        setMP({ ...element });
      }
    });
  };
  const lang = sessionStorage.getItem("lang");

  const IndustryData = async () => {
    try {
      const getOneAxios = await axiosData.get(`/General/seekerSettings`);
      const data = getOneAxios?.data?.industryData;
      if (data) {
        setIndustryArray(data);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  const experienceData = async () => {
    try {
      const getOneAxios = await axiosData.get(`/General/yearOfExperience`);
      const data = getOneAxios?.data?.experience;
      if (data) {
        setExperience(data);
      }
      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  const [location, setLocation] = useState("");

  const getCurrentLocation = async () => {
    try {
      const position = await getCurrentPosition();
      const { latitude, longitude } = position.coords;
      const locationName = await getLocationName(latitude, longitude);
      setLocation(locationName);
    } catch (error) {
      console.error("Error getting user location:", error);
    }
  };

  const getCurrentPosition = () =>
    new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });

  const getLocationName = async (latitude, longitude) => {
    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=18&addressdetails=1`
      );
      const address = response.data.display_name || "";
      const locationName = `${address}`;
      formik.setFieldValue("currentLocation", response?.data?.address?.city);
      return locationName;
    } catch (error) {
      console.error("Error fetching location details:", error);
      throw error;
    }
  };

  const [adDistrict, setAdDistrict] = useState([]);
  const [PincodeData, setPincodeData] = useState([]);
  const [PostOfficeData, setPostOfficeData] = useState([]);
  const [newPincode, setPincode] = useState([]);
  const [comdata, setComdata] = useState([]);
  const [pinLoad, setpinLoad] = useState(false);

  const areaPincode = async (values) => {
    setAdDistrict(values);

    try {
      setpinLoad(true);
      const getOneAxiospin = await axiosData.get(
        `/distritarea/getArea/${values}`
      );
      setpinLoad(false);
      const datapin = getOneAxiospin.data;
      if (datapin) {
        const getpin = datapin.map((i) => {
          return i.Pincode;
        });
        const getpost = datapin.map((i) => {
          return i.Post_Office;
        });
        const getpost1 = getpost[0];
        const result = getpin[0].reduce(
          (accumulator, currentPincode, index) => {
            return accumulator.concat(`${currentPincode}/${getpost1[index]}`);
          },
          []
        );
        const getPostFinal = result.map((i) => {
          return i;
        });
        setPincodeData(getpin[0]);
        setPostOfficeData(getpost[0]);
        setPincode(datapin);
        setComdata([...getPostFinal]);
      }

      return data;
    } catch (err) {
      console.log("Error", err);
    }
  };

  useEffect(() => {
    getCurrentLocation();
    vodingDistrict();
    IndustryData();
    experienceData();
  }, []);

  const handleClickWorkType = (e, id) => {
    e.preventDefault();
    setActive(id);
    if (id === "6") {
      SetWorktype("Fresher");
      formik.setFieldValue("Experience", "");
    } else if (id === "1") {
      SetWorktype("Experienced");
    }
  };

  useEffect(() => {
    if (formik.values.graduation === "Student") {
      SetWorktype("Fresher");
      formik.setFieldValue("Experience", "");
      setActive("6");
    }
    SetgraduationType(formik.values.graduation);
  }, [formik.values.graduation]);

  const handleStudentClick = () => {
    SetWorktype("Fresher");
    formik.setFieldValue("Experience", "");
    setActive("6");
  };

  const [pincodeNumData, setPincodeNumData] = useState([]);
  const [pincodeValue, setPincodeValue] = useState("");

  useEffect(() => {
    if (pincodeValue) {
      const parts = pincodeValue.split("/");
      if (parts.length === 2) {
        setPincodeNumData(parts);
      }
    }
  }, [formik.values.pincode]);

  if (ready) {
    return (
      <ThemeProvider theme={theme}>
        <Dialog TransitionComponent={Transition} open={emailPopUp}>
          <DialogTitle
            bgcolor="rgb(16 143 178)"
            sx={{ color: "white", fontWeight: 600 }}
          >
            {t("Email_Exits")}
          </DialogTitle>
          <DialogContent sx={{ mt: 3 }}>
            <DialogContentText sx={{ fontWeight: 600 }}>
              {t("This_Email_Id_already_exist")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setEmailPopUp(false)}
            >
              {t("Ok")}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog TransitionComponent={Transition} open={mobilePopUp}>
          <DialogTitle
            bgcolor="rgb(16 143 178)"
            sx={{ color: "white", fontWeight: 600 }}
          >
            {t("Mobile_Number_Exits")}
          </DialogTitle>
          <DialogContent sx={{ mt: 3 }}>
            <DialogContentText sx={{ fontWeight: 600 }}>
              {t("This_Mobile_number_already_exist")}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setMobilePopUp(false)}
            >
              {t("Ok")}
            </Button>
          </DialogActions>
        </Dialog>
        <Grid
          container
          component="main"
          sx={{ height: "100vh" }}
          className="mainGrid"
        >
          <CssBaseline />
          <Grid className="imgGrid" item xs={false} sm={false} md={4}>
            <Box>
              <Box className="sideReg">
                <div className="logo1">
                  <img src={logo} alt="logo" style={{ width: "75%" }} />
                </div>
                <Typography
                  variant="h5"
                  component="div"
                  className={lang === "tamil" ? "side-tamil-1" : "side-english"}
                  gutterBottom
                  sx={{ fontWeight: "bold" }}
                >
                  {t("Side_Content")}
                </Typography>
                <Box sx={{ display: "flex" }}>
                  <CheckCircleIcon
                    sx={{ mb: -0.6, mr: 0.5, color: "green" }}
                    color="green"
                  />{" "}
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    gutterBottom
                    className={lang === "tamil" ? "side-tamil" : "side-english"}
                  >
                    {t("Build_your_profile")}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex" }}>
                  <CheckCircleIcon sx={{ mb: -0.6, mr: 0.5, color: "green" }} />{" "}
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    className={lang === "tamil" ? "side-tamil" : "side-english"}
                    gutterBottom
                  >
                    {t("Get_job_postings")}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex" }}>
                  <CheckCircleIcon sx={{ mb: -0.6, mr: 0.5, color: "green" }} />{" "}
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    gutterBottom
                    className={lang === "tamil" ? "side-tamil" : "side-english"}
                  >
                    {t("Find_a_job")}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid
            className="secondGrid"
            item
            xs={12}
            sm={12}
            md={8}
            component={Paper}
            elevation={7}
          >
            <form onSubmit={formik.handleSubmit}>
              <Box
                sx={{
                  my: 8,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <IconButton
                  sx={{ border: "2px solid rgb(237 30 112)", mt: -3, mb: 2 }}
                >
                  <SearchIcon sx={{ fontSize: 50, color: "rgb(237 30 112)" }} />
                </IconButton>

                <Typography
                  sx={{ color: "rgb(19 92 130)" }}
                  className="example"
                  component="h1"
                  variant="h5"
                >
                  {t("JobSeeker_Registration")}
                </Typography>

                <Box sx={{ mt: 3 }}>
                  <FormControl fullWidth>
                    <TextField
                      margin="normal"
                      fullWidth
                      required
                      placeholder={t("Enter_Your_Full_Name")}
                      id="full_name"
                      label={t("Full_Name")}
                      name="full_name"
                      sx={{ margin: "0" }}
                      onBlur={formik.handleBlur}
                      onChange={(e) => {
                        if (e) {
                          const name = e.target.value.replace(
                            /[^a-z'. ]/gi,
                            ""
                          );
                          formik.setFieldValue("full_name", name);
                        }
                      }}
                      value={formik.values.full_name}
                      InputLabelProps={{
                        style: { color: "black" },
                      }}
                      InputProps={{
                        style: { color: "black" },
                        startAdornment: (
                          <InputAdornment position="start">
                            <AccountCircleIcon />{" "}
                          </InputAdornment>
                        ),
                      }}
                    />
                    <FormHelperText>
                      {formik.touched.full_name && formik.errors.full_name ? (
                        <Typography sx={{ color: "red" }}>
                          {formik.errors.full_name}
                        </Typography>
                      ) : (
                        <Typography sx={{ visibility: "hidden" }}>
                          none
                        </Typography>
                      )}
                    </FormHelperText>
                  </FormControl>

                  <FormControl fullWidth>
                    <TextField
                      margin="normal"
                      fullWidth
                      required
                      ref={ref}
                      onBlurCapture={() => {
                        setfocus(true);
                      }}
                      placeholder={t("Enter_Your_Email_ID")}
                      id="email_id"
                      label={t("Email_Id")}
                      name="formEmail"
                      onBlur={handleEmailBlur}
                      onChange={handleEmailChange}
                      value={formEmail}
                      InputLabelProps={{
                        style: { color: "black" },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <MailOutlineIcon />{" "}
                          </InputAdornment>
                        ),
                      }}
                    />
                    {formEmailError && focusout ? (
                      <div style={{ color: "red" }}>{formEmailError}</div>
                    ) : null}
                  </FormControl>

                  <FormControl fullWidth sx={{ mb: 1 }}>
                    <TextField
                      margin="normal"
                      required
                      placeholder={t("Enter_Your_Mobile_Number")}
                      name="mobile_number"
                      label={t("Mobile_Number")}
                      type="Number"
                      onWheel={(e) => {
                        e.preventDefault();
                        e.target.blur();
                      }}
                      onKeyDown={(e) =>
                        exceptThisSymbols.includes(e.key) && e.preventDefault()
                      }
                      id="mobile_number"
                      onBlurCapture={() => {
                        setfocusb(true);
                      }}
                      onBlur={formik.handleBlur}
                      onChange={handleChange}
                      value={formik.values.mobile_number}
                      InputLabelProps={{
                        style: { color: "black" },
                      }}
                      InputProps={{
                        maxLength: 10,
                        startAdornment: (
                          <InputAdornment position="start">
                            <b>+91</b>
                          </InputAdornment>
                        ),
                      }}
                    />
                    {mobileError && focusb ? (
                      <div style={{ color: "red" }}>{mobileError}</div>
                    ) : null}
                    {formik.touched.mobile_number &&
                    formik.errors.mobile_number &&
                    focusb ? (
                      <div style={{ color: "red" }}>
                        {formik.errors.mobile_number}
                      </div>
                    ) : null}
                  </FormControl>

                  <FormControl sx={{ mb: 1 }} fullWidth>
                    <FormLabel
                      align="left"
                      id="demo-row-radio-buttons-group-label"
                      required
                    >
                      {t("Gender")}
                    </FormLabel>
                    <RadioGroup
                      defaultValue={t("Male")}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="gender"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.gender}
                    >
                      <FormControlLabel
                        value="Male"
                        control={<Radio />}
                        label={t("Male")}
                      />
                      <FormControlLabel
                        value="Female"
                        control={<Radio />}
                        label={t("Female")}
                      />
                      <FormControlLabel
                        value="other"
                        control={<Radio />}
                        label={t("Other")}
                      />
                    </RadioGroup>
                    {formik.touched.gender && formik.errors.gender ? (
                      <div style={{ color: "red" }}>{formik.errors.gender}</div>
                    ) : null}
                  </FormControl>

                  <FormControl fullWidth>
                    <FormLabel
                      align="left"
                      id="demo-row-radio-buttons-group-label"
                      required
                    >
                      {t("Graduation")}
                    </FormLabel>
                    <RadioGroup
                      defaultValue={t("Male")}
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="graduation"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.graduation}
                    >
                      <FormControlLabel
                        value="Student"
                        control={<Radio />}
                        label={t("Student")}
                        onClick={handleStudentClick}
                      />
                      <FormControlLabel
                        value="Graduate"
                        control={<Radio />}
                        label={t("Graduate")}
                      />
                    </RadioGroup>
                    {formik.touched.graduation && formik.errors.graduation ? (
                      <div style={{ color: "red" }}>{formik.errors.gender}</div>
                    ) : null}
                  </FormControl>

                  {formik.values.graduation === "Graduate" ? (
                    <fieldset className="importantBox1">
                      <legend>{t("Work_Status")}</legend>
                      <Box
                        className="Box"
                        sx={{
                          display: "flex",
                          flexDirection: "row",

                          "& > :not(style)": {
                            m: 1,

                            height: 50,
                            p: 2,
                          },
                        }}
                      >
                        <div
                          className={`qualificationBox ${
                            active === "6" ? "active5" : ""
                          }`}
                          onClick={(e) => handleClickWorkType(e, "6")}
                        >
                          <div className="qualification">
                            <SchoolOutlinedIcon sx={{ mt: -0.9 }} />
                            <span className="space"></span>
                            <Typography
                              sx={{ mt: -1.3 }}
                              className={
                                lang === "tamil"
                                  ? "side-tamil"
                                  : "qualificationName"
                              }
                            >
                              {t("I'm_a_Fresher")}
                            </Typography>
                          </div>
                        </div>

                        <div
                          className={`qualificationBox ${
                            active === "1" ? "active5" : ""
                          }`}
                          onClick={(e) => handleClickWorkType(e, "1")}
                        >
                          <div className="qualification">
                            <WorkOutlineOutlinedIcon sx={{ mt: -0.9 }} />
                            <span className="space"></span>
                            <Typography
                              variant="h6"
                              component="div"
                              sx={{ mt: -1.3 }}
                              className={
                                lang === "tamil"
                                  ? "side-tamil"
                                  : "qualificationName1"
                              }
                            >
                              {t("I'm_Experienced")}
                            </Typography>
                          </div>
                        </div>
                      </Box>
                    </fieldset>
                  ) : null}

                  {formik.values.graduation === "Graduate" &&
                  WorkType === "Experienced" ? (
                    <FormControl sx={{ mt: 2 }} fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        {t("Work_Experience")}
                      </InputLabel>

                      <Select
                        name="Experience"
                        labelId="demo-simple-select-label"
                        id="Experience"
                        label="Work Experience"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.Experience}
                        MenuProps={MenuProps}
                      >
                        {experience
                          ? experience.map((data, index) => (
                              <MenuItem value={data} keys={index}>
                                {data}
                              </MenuItem>
                            ))
                          : null}
                      </Select>
                      {formik.touched.Experience && formik.errors.Experience ? (
                        <div style={{ color: "red" }}>
                          {formik.errors.Experience}
                        </div>
                      ) : null}
                    </FormControl>
                  ) : null}

                  {industryArray && (
                    <FormControl sx={{ mt: 3, mb: 1 }} fullWidth required>
                      <Autocomplete
                        disableClearable={formik.values.industry ? false : true}
                        filterOptions={filterOptions}
                        id="industry"
                        name="industry"
                        options={industryArray}
                        onBlur={formik.handleBlur}
                        onChange={(event, value) => {
                          setSelectedIndustry(value);
                          formik.setFieldValue("industry", value);
                        }}
                        value={formik.values.industry}
                        renderInput={(params) => (
                          <TextField
                            required
                            {...params}
                            id="industry"
                            label={t("Preffered_Industry")}
                            name="industry"
                            // onClick={() => params.inputProps.onInputClick()}
                          />
                        )}
                        onOpen={(event) => event.preventDefault()}
                        PopperComponent={({ children, ...popperProps }) => (
                          <Popper
                            {...popperProps}
                            placement="bottom-start"
                            modifiers={{
                              flip: {
                                enabled: false,
                              },
                              preventOverflow: {
                                enabled: true,
                                boundariesElement: "scrollParent",
                              },
                            }}
                            PopperProps={{
                              placement: "bottom-start", // Placement set to "bottom-start"
                            }}
                          >
                            <Paper>{children}</Paper>
                          </Popper>
                        )}
                        ListboxProps={{
                          style: { maxHeight: "180px", overflowY: "auto" },
                        }}
                      />
                      {formik.touched.industry && formik.errors.industry ? (
                        <div style={{ color: "red" }}>
                          {formik.errors.industry}
                        </div>
                      ) : null}
                    </FormControl>
                  )}

                  <TextField
                    margin="normal"
                    fullWidth
                    required
                    multiline
                    placeholder={t("Mention_the_city_you_live_in")}
                    id="Current Location"
                    label={t("Current_Location")}
                    name="currentLocation"
                    onBlur={formik.handleBlur}
                    onChange={(e) => {
                      if (e) {
                        const value = e.target.value.replace(
                          /[^a-z.,' ]/gi,
                          ""
                        );
                        formik.setFieldValue("currentLocation", value);
                      }
                    }}
                    value={formik.values.currentLocation}
                    InputLabelProps={{
                      style: { color: "black" },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LocationOnIcon />{" "}
                        </InputAdornment>
                      ),
                    }}
                  />
                  {formik.touched.currentLocation &&
                  formik.errors.currentLocation ? (
                    <div style={{ color: "red" }}>
                      {formik.errors.currentLocation}
                    </div>
                  ) : null}

                  {/* <fieldset className="importantBox">
                    <legend>{t("Voting_Details")} </legend>

                    <Container fixed>
                      <Autocomplete
                        fullWidth
                        disableClearable={
                          formik.values.votingDistrict ? false : true
                        }
                        filterOptions={filterOptions}
                        name="votingDistrict"
                        id="votingDistrict"
                        value={formik.values.votingDistrict}
                        onChange={(event, value) => {
                          formik.setFieldValue("votingDistrict", value);
                          formik.setFieldValue("mpConstituency", "");
                          formik.setFieldValue("mlaConstituency", "");
                          mlaSelection(value);
                          areaPincode(value);
                          formik.setFieldValue("pincode", "");
                        }}
                        onBlur={formik.handleBlur}
                        options={districtData}
                        getOptionLabel={(option) => option}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t("District")}
                            // onClick={() => params.inputProps.onInputClick()}
                            InputLabelProps={{
                              style: { marginLeft: "7px" },
                            }}
                          />
                        )}
                        onOpen={(event) => event.preventDefault()}
                        PopperComponent={({ children, ...popperProps }) => (
                          <Popper
                            {...popperProps}
                            placement="bottom-start"
                            modifiers={{
                              flip: {
                                enabled: false,
                              },
                              preventOverflow: {
                                enabled: true,
                                boundariesElement: "scrollParent",
                              },
                            }}
                            PopperProps={{
                              placement: "bottom-start", // Placement set to "bottom-start"
                            }}
                          >
                            <Paper>{children}</Paper>
                          </Popper>
                        )}
                        ListboxProps={{
                          style: { maxHeight: "180px", overflowY: "auto" },
                        }}
                      />{" "}
                      {formik.touched.votingDistrict &&
                      formik.errors.votingDistrict &&
                      !formik.values.votingDistrict ? (
                        <div style={{ color: "red" }}>
                          {formik.errors.votingDistrict}
                        </div>
                      ) : null}
                      <Tooltip
                        title={
                          formik.values.votingDistrict
                            ? null
                            : t("Select_District")
                        }
                        arrow
                      >
                        <FormControl
                          disabled={formik.values.votingDistrict ? false : true}
                          sx={{ mt: 2 }}
                          fullWidth
                          required
                        >
                          <InputLabel
                            sx={{ ml: 1 }}
                            id="demo-simple-select-label"
                          >
                            {t("MP_Constituency")}
                          </InputLabel>
                          <Select
                            name="mpConstituency"
                            labelId="demo-simple-select-label"
                            id="mpConstituency"
                            label="MP Constituency"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.mpConstituency}
                          >
                            {mpConstituency.ParlimentConstituency.map(
                              (element, index) => {
                                return (
                                  <MenuItem
                                    key={index}
                                    value={element}
                                    onClick={() => {
                                      mlaConstituency = [];
                                      mpConstituency[element].map((element) => {
                                        mlaConstituency.push(element);
                                        setMLA([...mlaConstituency]);
                                        formik.setFieldValue(
                                          "mlaConstituency",
                                          ""
                                        );
                                      });
                                    }}
                                  >
                                    {element}
                                  </MenuItem>
                                );
                              }
                            )}
                          </Select>
                          {formik.touched.mpConstituency &&
                          formik.errors.mpConstituency ? (
                            <div style={{ color: "red" }}>
                              {formik.errors.mpConstituency}
                            </div>
                          ) : null}
                        </FormControl>
                      </Tooltip>
                      <Tooltip
                        title={
                          formik.values.mpConstituency
                            ? null
                            : t("Select_MP_Constituency")
                        }
                        arrow
                      >
                        <FormControl
                          disabled={formik.values.mpConstituency ? false : true}
                          sx={{ mt: 2 }}
                          fullWidth
                          required
                        >
                          <InputLabel
                            sx={{ ml: 1 }}
                            id="demo-simple-select-label"
                          >
                            {t("MLA_Constituency")}
                          </InputLabel>
                          <Select
                            name="mlaConstituency"
                            labelId="demo-simple-select-label"
                            id="mlaConstituency"
                            label="mlaConstituency"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.mlaConstituency}
                          >
                            {mlaConstituency.map((element, index) => {
                              return (
                                <MenuItem key={index} value={element}>
                                  {element}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          {formik.touched.mlaConstituency &&
                          formik.errors.mlaConstituency ? (
                            <div style={{ color: "red" }}>
                              {formik.errors.mlaConstituency}
                            </div>
                          ) : null}
                        </FormControl>
                      </Tooltip>
                      <Tooltip
                        title={
                          formik.values.votingDistrict
                            ? null
                            : t("Select_District")
                        }
                        arrow
                      >
                        <FormControl sx={{ mt: 3, mb: 1 }} fullWidth required>
                          <Autocomplete
                            disabled={
                              formik.values.votingDistrict && !pinLoad
                                ? false
                                : true
                            }
                            disableClearable={
                              formik.values.pincode ? false : true
                            }
                            filterOptions={filterOptions}
                            id="pincode"
                            name="pincode"
                            options={comdata}
                            onBlur={formik.handleBlur}
                            onChange={(event, value) => {
                              formik.setFieldValue("pincode", value);
                              setPincodeValue(value);
                            }}
                            value={formik.values.pincode}
                            renderInput={(params) => (
                              <TextField
                                required
                                {...params}
                                id="pincode"
                                label={t("Pincode")}
                                name="pincode"
                                InputLabelProps={{
                                  style: { color: "black", marginLeft: "7px" },
                                }}
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      {pinLoad ? (
                                        <CircularProgress
                                          // size={24}
                                          style={{
                                            width: "1.7rem",
                                            height: "1.7rem",
                                            color:
                                              formik.errors.pincode ===
                                                undefined ||
                                              formik.touched.pincode ===
                                                undefined
                                                ? "#1976d5"
                                                : formik.errors.pincode !==
                                                    undefined &&
                                                  formik.touched.pincode ===
                                                    true
                                                ? "#de6363"
                                                : "#666666",
                                          }}
                                        />
                                      ) : (
                                        <ShareLocationRoundedIcon
                                          sx={{
                                            color:
                                              formik.errors.pincode ===
                                                undefined ||
                                              formik.touched.pincode ===
                                                undefined
                                                ? "#1976d5"
                                                : formik.errors.pincode !==
                                                    undefined &&
                                                  formik.touched.pincode ===
                                                    true
                                                ? "#de6363"
                                                : "#666666",
                                          }}
                                        />
                                      )}{" "}
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            )}
                            onOpen={(event) => event.preventDefault()}
                            PopperComponent={({ children, ...popperProps }) => (
                              <Popper
                                {...popperProps}
                                placement="bottom-start"
                                modifiers={{
                                  flip: {
                                    enabled: false,
                                  },
                                  preventOverflow: {
                                    enabled: true,
                                    boundariesElement: "scrollParent",
                                  },
                                }}
                                PopperProps={{
                                  placement: "bottom-start", // Placement set to "bottom-start"
                                }}
                              >
                                <Paper>{children}</Paper>
                              </Popper>
                            )}
                            ListboxProps={{
                              style: { maxHeight: "180px", overflowY: "auto" },
                            }}
                          />
                          {formik.touched.pincode && formik.errors.pincode ? (
                            <div style={{ color: "red" }}>
                              {formik.errors.pincode}
                            </div>
                          ) : null}
                        </FormControl>
                      </Tooltip>
                    </Container>
                  </fieldset> */}

                  <Grid className="container">
                    <Grid item sx={{ mt: 0 }} xs={5} sm={5} md={6} lg={6}>
                      <input
                        className="resumefile"
                        id="file-upload"
                        type="file"
                        accept=".docx,.doc,.pdf,"
                        onChange={handleFileChange}
                        ref={fileInputField}
                        required
                      />
                      <div className="fileuploadcenter">
                        <Button
                          disabled={file ? true : false}
                          htmlFor="file"
                          variant="contained"
                          color="error"
                          sx={{ borderRadius: 10, mr: -2 }}
                          className="fileUpload"
                          name="fileUpload"
                          onClick={() => {
                            fileInputField.current.click();
                          }}
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          value={formik.values.fileUpload}
                        >
                          <DriveFolderUploadIcon className="resumeIcon" />
                          {t("Upload_Resume")}
                        </Button>
                      </div>
                    </Grid>
                    <Grid sx={{ mt: 2.5 }} item xs={7} sm={7} md={6} lg={6}>
                      {file ? (
                        <div className="fileName">
                          <Typography
                            variant="div"
                            sizewidth="2px"
                            sx={
                              resume
                                ? { color: "rgb(16 143 178)", ml: -1, mb: -1 }
                                : { color: "red", ml: -1, mb: -1 }
                            }
                            className="fileNameSize"
                          >
                            {`${file}`}
                          </Typography>
                          <Tooltip title="Clear" arrow>
                            <IconButton>
                              <CloseIcon
                                className="iconsize"
                                sx={{ color: "red", mb: -0.5 }}
                                onClick={() => {
                                  deleteFile();
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                  <div className="uploadbox">
                    <p>
                      <span
                        style={
                          resume
                            ? { color: "rgb(16 143 178)" }
                            : { color: "red" }
                        }
                        className="fileSize"
                      >
                        {data
                          ? `${data / 1024}` >= 1024
                            ? `${parseFloat(data / 1024 / 1024).toFixed(3)}Mb`
                            : `${parseFloat(data / 1024).toFixed(3)}Kb`
                          : null}
                      </span>{" "}
                      {t("File_must_be")}
                    </p>
                  </div>

                  <Button
                    type="submit"
                    disabled={
                      !formEmailError &&
                      resume &&
                      formik.isValid &&
                      formik.dirty &&
                      isSubmitting === false
                        ? false
                        : true
                    }
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                  >
                    {t("Submit")}
                    {isSubmitting && (
                      <CircularProgress
                        size={24}
                        style={{
                          color: "#ffffff",

                          marginLeft: 12,
                        }}
                      />
                    )}
                  </Button>
                </Box>
              </Box>
            </form>
          </Grid>
        </Grid>
        <Outlet />
      </ThemeProvider>
    );
  } else {
    return (
      <div
        style={{
          height: "70vh",
          display: "grid",
          placeItems: "center",
        }}
      >
        <div class="dots"></div>
      </div>
    );
  }
}
export default JobSeekerRegForm;
